import { generatePath, useLoaderData, useLocation, useNavigate } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { SubscriptionCategory } from '../../../../../common/enums.js';
import { useGetServiceFeeSim } from '../../../../../common/hooks/useGetServiceFeeSim';
import { activateSimCardMsg, omaElisaForCompaniesMsg, t, voiceSubscriptionsMsg } from '../../../../../common/i18n';
import { getSubscriptionBreadcrumbName, getSubscriptionUrlId } from '../../../../../common/utils/subscriptionUtils.js';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { SimActivation } from '../../../../../components/SimActivation/SimActivation.js';
import type { MobileSubPostChangeRequestLoaderResponse } from '../../../../../common/loaders';

export const MobileSubActivateSimPath = () => {
  const { companyInfo, hasPendingActions, subscription } = useLoaderData() as MobileSubPostChangeRequestLoaderResponse;
  const getServiceFeeSim = useGetServiceFeeSim();
  const { search } = useLocation();
  const navigate = useNavigate();

  return (
    <SimActivation
      breadCrumbs={
        <BreadCrumbsWithTitle
          breadCrumbPaths={[
            { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
            { name: t.AR0B(voiceSubscriptionsMsg), path: paths.PS_MOBILE_SUBSCRIPTIONS },
            {
              name: getSubscriptionBreadcrumbName(subscription),
              path:
                generatePath(paths.PS_MOBILE_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) }) +
                search,
            },
            { name: t.M1E7(activateSimCardMsg) },
          ]}
        />
      }
      category={SubscriptionCategory.VOICE}
      companyInfo={companyInfo}
      disallowBillableSimChanges={false}
      getServiceFeeSim={getServiceFeeSim}
      hasPendingActions={hasPendingActions}
      onClickOrderSim={() =>
        navigate(
          generatePath(paths.PS_MOBILE_SUBSCRIPTION_ORDER_SIM, {
            subscriptionId: getSubscriptionUrlId(subscription),
          }) + search
        )
      }
      onClickSubscription={() => {
        navigate(
          generatePath(paths.PS_MOBILE_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) }) + search
        );
      }}
      subscription={subscription}
    />
  );
};
